const HTML_ESCAPE_PATTERN = /[&<>"']/g;
const HTML_ESCAPE_CHARS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

export function escapeHtml(value) {
  return String(value ?? '').replace(HTML_ESCAPE_PATTERN, (char) => HTML_ESCAPE_CHARS[char]);
}

export function escapeAttribute(value) {
  return escapeHtml(value);
}

// Neutralizes a literal closing tag (e.g. `</script>`) inside text that gets
// interpolated into a same-named HTML element, so the HTML parser doesn't
// terminate the element early on user-authored content. The inserted
// backslash is inert in both HTML (it breaks the `</tag` lookahead) and in
// the interpolated source (an escaped `/` is a no-op inside a string/regex
// literal, which is where a literal closing tag realistically occurs).
function escapeClosingTag(value, tagName) {
  const pattern = new RegExp(`<\\/(${tagName})`, 'gi');
  return String(value ?? '').replace(pattern, '<\\/$1');
}

export function escapeScriptClose(value) {
  return escapeClosingTag(value, 'script');
}

export function escapeStyleClose(value) {
  return escapeClosingTag(value, 'style');
}
